export default function registerIbDateFormatFilter(module) {
    /**
     * Registers the 'ibDateFormat' filter with the provided AngularJS module.
     * This filter formats a given date value according to a specified format name.
     * 
     * @param {object} module - The AngularJS module to register the filter with.
     */
    module.filter('ibDateFormat', ['$window', '$config', function ($window, $config) {
        'use strict';

        /**
         * The filter function that formats a date value.
         * 
         * @param {string|number|Date} value - The date value to format. Can be a string, number (milliseconds since epoch), or Date object.
         * @param {string} formatName - The name of the date format to use, as defined in the configuration.
         * @returns {string} - The formatted date string.
         */
        return function (value, formatName) {

            // SMELL: This check could be more robust by using a utility function to determine if the value is a valid date.
            if (typeof value === 'undefined' || value === null) {
                return '';
            }

            if (angular.isNumber(value)) {
                // Convert milliseconds since the epoch to a Date object
                value = new Date(value);
            } else if (!(value instanceof Date)) {
                // Attempt to parse the value as a date string
                value = new Date(value);
            }

            // Check if the value is a valid date
            if (isNaN(value.getTime())) {
                return '';
            }

            return $window.moment(value).format($config.getDateFormat(formatName));
        };
    }]);
}